import commonConstant from '../../common/_commonConstant';
import { checkTimeToRefreshToken, getCookieToken } from '../../common/_commonFunction';
import { filterIoTPosition, history } from '../../helpers';
import { fetchRefreshToken } from '../../actions';

export const fetchGetIoTDevices = (buildingID, buildingIotDeviceTypes, buildingIotDeviceLocations) => (
  async dispatch => {
    try {
      const res = await fetch(`${commonConstant.envDomainAPI}/iot-devices?buildingID=${buildingID}${buildingIotDeviceTypes ? `&buildingIotDeviceTypes=${buildingIotDeviceTypes}` : ''}${buildingIotDeviceLocations ? `&buildingIotDeviceLocations${buildingIotDeviceLocations}` : ''}`, {
        'headers': new Headers({
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${getCookieToken()}`,
        }),
      });
      const data = await res.json();

      if (checkTimeToRefreshToken()) {
        dispatch(fetchRefreshToken());
      }
      if (res.status === 200) {
        return dispatch({
          'type': commonConstant.GET_IOT_DEVICES_SUCCESS,
          'data': filterIoTPosition(data.data),
          'status': res.status,
          'dateTime': new Date(),
        });
      } else if (res.status === 401) {
        return history.push(commonConstant.pathLogout);
      } else if (res.status === 500 || res.status === 502) {
        return history.push(commonConstant.pathServerError);
      }
      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
        'errorMessage': data.detail ? data.detail : null,
      });
      return dispatch({
        'type': commonConstant.GET_IOT_DEVICES_FAILURE,
        'data': null,
        'status': res.status ? res.status : res,
        'dateTime': new Date(),
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.GET_IOT_DEVICES_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'dateTime': new Date(),
      });
    }
  }
);

export const fetchIoTPublishInformation = (formInformation, buildingRefNo) => (
  async dispatch => {
    try {
      if (formInformation && buildingRefNo) {
        const res = await fetch(`${commonConstant.envDomainAPI}/iot-devices/publish-information`, {
          'headers': new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${getCookieToken()}`,
          }),
          'method': 'POST',
          'body': JSON.stringify(formInformation),
        });
        const data = await res.json();

        if (checkTimeToRefreshToken()) {
          dispatch(fetchRefreshToken());
        }
        if (res.status === 200) {
          return dispatch({
            'type': commonConstant.PUBLISH_IOT_INFORMATION_SUCCESS,
            'data': data.data,
            'status': res.status,
            'errorMessage': null,
            'dateTime': new Date(),
            formInformation,
          });
        } else if (res.status === 401) {
          return history.push(commonConstant.pathLogout);
        } else if (res.status === 500 || res.status === 502) {
          return history.push(commonConstant.pathServerError);
        }

        dispatch({
          'type': commonConstant.SHOW_ERROR_MESSAGE,
          'data': null,
          'status': res.status ? res.status : res,
          'dateTime': new Date(),
          'errorMessage': data.detail ? data.detail : null,
        });
        return dispatch({
          'type': commonConstant.PUBLISH_IOT_INFORMATION_FAILURE,
          'data': null,
          'status': res.status ? res.status : null,
          'errorMessage': data.detail ? data.detail : null,
          'dateTime': new Date(),
          formInformation,
        });
      }

      dispatch({
        'type': commonConstant.SHOW_ERROR_MESSAGE,
        'data': 'formInformation or buildingRefNo is undefined',
        'status': 400,
        'dateTime': new Date(),
        'errorMessage': null,
      });
      return dispatch({
        'type': commonConstant.PUBLISH_IOT_INFORMATION_FAILURE,
        'data': null,
        'status': 400,
        'errorMessage': 'formInformation or buildingRefNo is undefined',
        'dateTime': new Date(),
        formInformation,
      });
    } catch (err) {
      return dispatch({
        'type': commonConstant.PUBLISH_IOT_INFORMATION_FAILURE,
        'data': null,
        'status': err.status ? err.status : err,
        'errorMessage': null,
        'dateTime': new Date(),
        formInformation,
      });
    }
  }
);

